<!-- HERO -->
<header class="masthead">
  <div class="container h-100">
    <div class="row h-100 align-items-center">
      <div class="col-12 text-center">
        <h1 class="outline-title">Digital Media Center</h1>
      </div>
    </div>
  </div>
</header>

<section class="modern-service-hero-section py-5">
  <div class="container px-5 my-5">
    <div class="row align-items-center">
      <div class="col-lg-7">
        <a class="service-detail-back" routerLink="/servicios">
          <i class="bi bi-arrow-left"></i>
          Servicios
        </a>
        <h1 class="modern-section-title mb-3">
          Contenido, campañas y medios trabajando como <span class="highlight-green">un solo sistema</span>
        </h1>
        <div class="section-underline"></div>
        <p class="lead text-light mb-4">
          Creatividad, tecnología y estrategia para construir presencia digital con intención comercial.
        </p>
        <ul class="modern-checklist">
          <li><i class="bi bi-check-circle-fill"></i> Colaboración estratégica personalizada</li>
          <li><i class="bi bi-check-circle-fill"></i> Análisis de rendimiento detallado</li>
          <li><i class="bi bi-check-circle-fill"></i> Contenido multimedia de alto impacto</li>
        </ul>
      </div>
      <div class="col-lg-5 text-center">
        <app-service-orbit-visual iconClass="bi bi-camera-video"></app-service-orbit-visual>
      </div>
    </div>
  </div>
</section>

<!-- CARDS DE SERVICIOS -->
<section class="modern-service-cards-section py-5">
  <div class="container">
    <div class="row g-4">
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="bi bi-images"></i>
          </div>
          <h4 class="modern-service-card-title">Contenido Multimedia</h4>
          <p>Creamos piezas visuales y narrativas diseñadas para conectar con audiencias reales.</p>
        </div>
      </div>
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="bi bi-bullseye"></i>
          </div>
          <h4 class="modern-service-card-title">Campañas Estratégicas</h4>
          <p>Diseñamos campañas multimedia 360° para maximizar visibilidad y coherencia de marca.</p>
        </div>
      </div>
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="bi bi-broadcast"></i>
          </div>
          <h4 class="modern-service-card-title">Estrategia Omnicanal</h4>
          <p>Unificamos mensaje, canales y experiencia para construir una presencia más sólida.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- SECCIÓN POR QUÉ ELEGIRNOS -->
<section class="modern-service-why-section py-5">
  <div class="container px-5 my-5">
    <div class="row align-items-center">
      <div class="col-md-6">
        <h2 class="modern-section-title mb-3">
          ¿Por qué <span class="highlight-green">elegirnos?</span>
        </h2>
        <div class="section-underline"></div>
        <ul class="modern-checklist">
          <li><i class="bi bi-check-circle-fill"></i> Colaboración cercana con el cliente</li>
          <li><i class="bi bi-check-circle-fill"></i> Experiencias multimedia integradas</li>
          <li><i class="bi bi-check-circle-fill"></i> Ajustes y optimización continua</li>
        </ul>
      </div>
      <div class="col-md-6">
        <div class="glass-card p-4">
          <p class="mb-0 text-light">
            Elevemos tu presencia digital con contenido que trabaja para tu estrategia.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
